import { Button, InputNumber, Input, List, Popconfirm, Tag, Typography, Space } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { fmt } from "./tenantPackageHelpers";

const { Text } = Typography;

interface Props {
  charges: any[];
  chargesLoading: boolean;
  currentPackageId: string | undefined;
  chargeAmount: number | null;
  onChargeAmountChange: (value: number | null) => void;
  chargeDesc: string;
  onChargeDescChange: (value: string) => void;
  onAddCharge: () => void;
  addChargePending: boolean;
  onDeleteCharge: (chargeId: string) => void;
}

export const PackageAdditionalCharges: React.FC<Props> = ({
  charges,
  chargesLoading,
  currentPackageId,
  chargeAmount,
  onChargeAmountChange,
  chargeDesc,
  onChargeDescChange,
  onAddCharge,
  addChargePending,
  onDeleteCharge,
}) => {
  return (
    <div className="bg-white p-4 rounded-xl border border-gray-200">
      <Text strong className="text-sm block mb-2">
        Additional Charges (extra features / adjustments)
      </Text>
      <div className="flex flex-col gap-2 mb-3">
        <Space.Compact className="w-full">
          <InputNumber
            className="flex-1"
            placeholder="Amount (use - for credit)"
            prefix="$"
            value={chargeAmount}
            onChange={(v) =>
              onChargeAmountChange(typeof v === "number" ? v : null)
            }
          />
        </Space.Compact>
        <Input
          placeholder="Reason (e.g. enabled WhatsApp module)"
          value={chargeDesc}
          onChange={(e) => onChargeDescChange(e.target.value)}
          className="text-xs"
        />
        <Button
          type="dashed"
          icon={<PlusOutlined />}
          loading={addChargePending}
          onClick={onAddCharge}
          disabled={!currentPackageId}
        >
          Add Charge
        </Button>
        {!currentPackageId && (
          <Text type="secondary" className="text-[11px]">
            Assign a plan first to bill extra features.
          </Text>
        )}
      </div>

      <List
        size="small"
        loading={chargesLoading}
        dataSource={charges}
        locale={{ emptyText: "No additional charges." }}
        renderItem={(item: any) => (
          <List.Item
            actions={[
              <Popconfirm
                key="del"
                title="Remove this charge?"
                onConfirm={() => onDeleteCharge(item.id)}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  type="text"
                  danger
                  size="small"
                  icon={<DeleteOutlined />}
                />
              </Popconfirm>,
            ]}
          >
            <List.Item.Meta
              title={
                <div className="flex items-center justify-between">
                  <span className="text-xs font-medium truncate max-w-[200px]">
                    {item.description || "Charge"}
                  </span>
                  <Tag
                    color={Number(item.amount) >= 0 ? "gold" : "red"}
                    bordered={false}
                  >
                    {Number(item.amount) >= 0 ? "+" : ""}
                    {fmt(Number(item.amount))}
                  </Tag>
                </div>
              }
              description={
                <span className="text-[11px] text-gray-400">
                  {item.created_at
                    ? new Date(item.created_at).toLocaleString()
                    : ""}
                </span>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};
